import styled from '@emotion/styled';
import { Component } from 'react';

import { altText } from '../../../Roofing/Shingles/imageAlts';
import { connectLocation } from '../../../location/LocationConnectors';

const ListItem = styled.li`
  display: inline-flex;
  margin: 0 0.25em 0.5em;
  position: relative;
  width: calc(25% - 0.5em);

  @media (min-width: 480px) {
    width: calc(16.666% - 0.5em);
  }

  @media (min-width: 1050px) {
    width: calc(12.5% - 0.5em);
  }
`;

const ColorLink = styled.a`
  align-items: flex-start;
  cursor: pointer;
  display: inline-flex;
  position: relative;
  width: 100%;

  &:after {
    border: 3px solid transparent;
    bottom: 0;
    content: '';
    left: 0;
    pointer-events: none;
    position: absolute;
    right: 0;
    top: 0;
    transition: all 0.15s ease-in-out;
  }

  &:hover,
  &.active {
    &:after {
      border-color: #d40f7d;
    }
  }
`;

const ColorImage = styled.img`
  height: auto;
  width: 100%;
`;

export default class ColorSwatch extends Component {
  constructor() {
    super();
    this.onToggle = this.onToggle.bind(this);
  }

  onToggle() {
    this.props.onToggle(this.props.colorData, !this.props.selected);
  }

  render() {
    const { colorData, locale, selected, tracking } = this.props;

    return (
      <ListItem>
        <ColorLink
          data-tip={colorData.name}
          data-effect="solid"
          className={`jsShingleSwatch note${selected ? ' active' : ''}`}
          {...tracking}
        >
          <ColorImage
            onClick={this.onToggle}
            src={colorData.swatch_160x160_url}
            alt={altText(colorData, 'swatch', 'en', colorData.name)}
            className="shingleswatch__image"
          />
        </ColorLink>
      </ListItem>
    );
  }
}
